import Input from "../../components/input";
import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import AddIcon from "../../components/icons/add-icon";
import { useEffect, useState } from "react";
import DeleteIcon from "../../components/icons/delete-icon";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import { useNavigate } from "react-router-dom";
import { getSupplier, getSupplierCount } from "src/firebase/admin.js";
import { handleToastMessage } from "src/js/handleToastMessage";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "src/firebase/firebase";
import Loader from "../../components/loader";
import { Formik } from "formik";
import * as Yup from "yup";
import { setDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import Profile from "../../pages/profile/profile";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";

const validationSchema = Yup.object().shape({
  accountLimit: Yup.number()
    .required("Account limit is required.")
    .typeError("Accept only number"),
});

const initValue = {
  accountLimit: "",
};

const pageSize = 200;
const UserManagement = () => {
  const { t } = useTranslation(["home"]);

  const [activeDeletedId, setActiveDeletedId] = useState(null);
  const [supplierList, setSupplierList] = useState([]);
  const [filterSuplierList, setFilterSuplierList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCards, setTotalCards] = useState<number>(1);
  const [addLoading, setAddLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [activeSupplier, setActiveSupplier] = useState(null);
  const [activeEditData, setActiveEditData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getSupplierList();
  }, [currentPage, searchText]);

  useEffect(() => {
    getSupperListCount();
  }, []);

  const getSupperListCount = async () => {
    const result = await getSupplierCount();
    setTotalCards(result);
  };

  const getSupplierList = async () => {
    setIsLoading(true);
    let result = await getSupplier(currentPage, pageSize, searchText);
    setIsLoading(false);

    result = result.map((item) => {
      return {
        ...item,
        id: item?.id,
        userName: `${item.firstName} ${item.lastName}`,
        email: item.email,
      };
    });

    setSupplierList(result);
    setFilterSuplierList(result);
  };

  const handleAllowSubmitCard = async (value, data) => {
    await setDoc(doc(db, "Accounts", data.id), {
      ...data,
      allowCardSubmit: value,
    });
  };
  const columns = [
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("ID")}</span>
    //     </div>
    //   ),
    //   dataIndex: "id",
    //   key: "id",
    //   width: 170,
    // },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("User Name")}</span>
        </div>
      ),
      dataIndex: "userName",
      key: "userName",
      width: 170,
      render: (userName: string) => <div>{userName}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Email ID")}</span>
        </div>
      ),
      dataIndex: "email",
      key: "email",
      width: 170,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Assign Limit")}</span>
        </div>
      ),
      dataIndex: "accountLimit",
      key: "accountLimit",
      width: 170,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "date",
      render: (date: any) => (
        <div>{date ? new Date(date.seconds * 1000).toDateString() : ""}</div>
      ),
      key: "date",
      width: 170,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Ability to submit the card")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 250,
      render: (id: string, row: any) => (
        <div className="flex gap-x-2">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={row?.allowCardSubmit === false ? false : true}
              onChange={(e) => handleAllowSubmitCard(e.target.checked, row)}
            />
            <span className="slider round"></span>
          </label>
        </div>
      ),
    },
  ];

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    // const docRef = doc(db, "Accounts", activeDeletedId);
    // deleteDoc(docRef).then((res) => {
    //   handleToastMessage("success", "Delete supplier successfully");
    //   setActiveDeletedId("");
    //   getSupplierList();
    // });

    let _activeSupplier = activeDeletedId;
    _activeSupplier.isEnable =
      _activeSupplier.isEnable === true ||
      _activeSupplier.isEnable === undefined
        ? false
        : true;
    await setDoc(doc(db, "Accounts", _activeSupplier.id), _activeSupplier);
    getSupplierList();
    setActiveDeletedId(null);
  };

  const handleAddAccountLimit = async (values: any) => {
    setAddLoading(true);
    let _activeSupplier = activeSupplier;
    _activeSupplier.accountLimit = values.accountLimit;
    await setDoc(doc(db, "Accounts", activeSupplier.id), _activeSupplier);
    setAddLoading(false);
    setActiveSupplier(null);
    getSupplierList();
  };
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Users")} {t("Management")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-semibold ">
            {t("Users")}{" "}
          </h1>
          <div className="flex gap-2 items-center">
            <Input
              name="keyword"
              placeholder={t("Search by keyword")}
              inputClassName="h-9"
              variant="solid"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterSuplierList}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          className="w-full mt-10"
          page={currentPage}
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId(null)}
      >
        <ConfirmationCard
          title={
            activeDeletedId?.isEnable === true ||
            activeDeletedId?.isEnable === undefined
              ? t("Disable this account")
              : t("Enable this account")
          }
          deleteBtnText="Yes"
          onCancel={() => setActiveDeletedId(null)}
          onDelete={handleDelete}
          description={
            activeDeletedId?.isEnable === true ||
            activeDeletedId?.isEnable === undefined
              ? t("Are you sure about disable this account?")
              : t("Are you sure about enable this account?")
          }
        />
      </Modal>
      <Modal
        open={activeSupplier ? true : false}
        onClose={() => setActiveSupplier(null)}
      >
        <div className="p-4 pb-6 bg-light m-auto  w-full rounded-md md:rounded-xl sm:w-[24rem]">
          <div className="w-full h-full">
            <div className="flex h-full flex-col justify-between mt-5">
              <Formik
                enableReinitialize
                initialValues={initValue}
                validationSchema={validationSchema}
                onSubmit={handleAddAccountLimit}
                validateOnBlur
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  setFieldTouched,
                  setFieldValue,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <Input
                        label="Account limit"
                        containerClass="w-full"
                        placeholder="Account limit"
                        name="accountLimit"
                        className="flex-1"
                        error={errors.accountLimit}
                        touched={touched.accountLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="solid"
                      />

                      <Button
                        loading={addLoading}
                        type="button"
                        className="mt-3"
                        onClick={handleSubmit as any}
                      >
                        Add
                      </Button>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={activeEditData ? true : false}
        onClose={() => setActiveEditData(null)}
        className="w-full"
      >
        <Profile
          isShowSideBar={false}
          user={activeEditData}
          updateProfile={() => {
            setActiveEditData(null);
            getSupplierList();
          }}
        />
      </Modal>
    </div>
  );
};
export default UserManagement;
